import {
    fetchListingAdditionalContent as fListingAdditionalContent
} from './utils/listings-additional-content';

export const fetchListingAdditionalContent = (listings, segmentKey) => (dispatch, getState) => {
    const {
        config: {
            template,
            url: {basePathPrefix},
        },
        destination: {details},
    } = getState();

    const data = listings.listings.reduce((total, currentValue) => {
        const {geoCode: {latitude, longitude}, tripleId} = currentValue;
        total[tripleId] = {
            latitude, longitude
        };
        return total;
    }, {});

    return fListingAdditionalContent({
        dispatch,
        segmentKey,
        data,
        listings,
        template,
        basePathPrefix,
        type: details.types[0]
    });
};
